export const DOMESTIC_COUNTRY_CODE = "US";
export const DOMESTIC_SHIPPING_CENTS = 1495;

const DOMESTIC_COUNTRY_ALIASES = new Set([
    "US",
    "USA",
    "UNITED STATES",
    "UNITED STATES OF AMERICA",
]);

export function normalizeCountryCode(value) {
    return String(value || "").trim().toUpperCase();
}

export function isDomesticShippingCountry(value) {
    return DOMESTIC_COUNTRY_ALIASES.has(normalizeCountryCode(value));
}

export function formatUsdCents(value) {
    return (Number(value || 0) / 100).toFixed(2);
}

export function getPortalBaseUrl() {
    const configured =
        process.env.PORTAL_V2_BASE_URL?.trim() ||
        process.env.UXD_PORTAL_URL?.trim() ||
        process.env.NEXT_PUBLIC_PORTAL_URL?.trim();

    const fallback =
        process.env.NODE_ENV === "development"
            ? "http://localhost:3010"
            : "https://portal.uxd.com";

    return (configured || fallback).replace(/\/+$/, "");
}
